module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei4.svg";